export default "__VITE_ASSET__BhyCqNkf__"